import clsx from "classnames";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getAsset } from "@/getters/getAsset";

export const BlobCard = ({ className, title, blob, children, ...props }) => {
  return (
    <a {...props} className={clsx(className, classes.card, "ratio ratio-1x1")}>
      <div
        className={clsx(classes.card__blob, classes[`card__blob--${blob}`])}
        style={{ backgroundImage: `url(${getAsset({ path: "card.blob.bg", size: "942x613" })})` }}
      />
      <div className={clsx(classes.card__details, "p-4")}>
        {/* Render children if they exist, otherwise fall back to the title prop */}
        {children || <h5 dangerouslySetInnerHTML={{ __html: title }} />}
      </div>
    </a>
  );
};

BlobCard.defaultProps = {
  blob: 1,
  onClick: null,
  title: null,
  children: null,
};

BlobCard.propTypes = {
  blob: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  title: PropTypes.string,
  children: PropTypes.node,
};